import { Button, Center, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import SRD_Form from "components/Form/index";
import { currentBsdState } from "pages/Login/atom/currentBsdState";
import { userState } from "pages/Login/atom/userState";
import { checkSameTelNo, insertSmsReceive, send_authcode } from "pages/SMS/ReceiveSetting/apis/receiveSettingApis";
import { authCodeState, bsdNmState, currentBsdListState, generatedCodeState } from "pages/atom/globalState";
import { useRecoilState } from "recoil";
import {
  deleteSmsReceive,
  updateSmsReceive
} from "../apis/receiveSettingApis";
const generateRandomNumber = () => {
  return Math.floor(1000 + Math.random() * 9000).toString();
};

// const AuthCodeInput = ({ onConfirm, onCancel, formData, data, bsdState, bsdList, navigate }) => {
const AuthCodeInput = ({ onConfirm, onCancel, formData, data, bsdList, onNavigate }) => {
  const [authCode, setAuthCode] = useRecoilState(authCodeState); 
  const [generatedCode, setGeneratedCode] = useRecoilState(generatedCodeState);
  const [errorMessage, setErrorMessage] = useState('');
  const [bsdState, setBsdState] = useRecoilState(currentBsdState);

  useEffect(() => {
    console.log("Generated Auth Code:", generatedCode);
  }, [generatedCode]);

  const handleAuthCodeChange = (event) => {
    const value = event.target.value.replace(/[^0-9]/g, '').slice(0, 4);
    console.log("Input value:", value);
    setAuthCode(value);
    setErrorMessage('');
  };

  const handleConfirm = async () => {
    console.log("< 확인 버튼 클릭후 > authCode:", authCode, "generatedCode:", generatedCode);
    if (authCode === generatedCode) {
      try {
        await insertSmsReceive({ ...formData }, bsdState);
        onConfirm(data);
        onNavigate("/sms/receive", { state: { bsdState } });
        modals.closeAll();
      } catch (error) {
        console.error("Error inserting SMS receive:", error);
        alert("SMS 수신자 등록 중 오류가 발생했습니다.");
      }
    } else {
      setErrorMessage("올바른 인증번호를 입력해주세요.");
      setAuthCode('');
      document.getElementById('authCodeInput').value = '';
    }
  };

  return (
    <div>
      <Text size="sm" style={{ marginBottom: '1rem' }}>인증번호를 입력하세요</Text>
      <Group align="flex-end" spacing="xs">
        <div>
          <label htmlFor="authCodeInput" style={{ display: 'none' }}>인증번호</label>
          <input
            id="authCodeInput"
            type="text"
            inputMode="numeric"
            placeholder="인증번호"
            onChange={handleAuthCodeChange}
            style={{ 
              width: '120px', 
              padding: '8px', 
              border: '1px solid #ced4da', 
              borderRadius: '4px',
              fontSize: '14px'
            }}
            maxLength={4}
          />
        </div>
        <Button onClick={handleConfirm}>
          확인
        </Button>
        <Button onClick={() => {
          const resendCode = generateRandomNumber();
          setGeneratedCode(resendCode);
          send_authcode(data, resendCode);   // 인증번호를 재전송하는 SMS
          console.log("Resending authentication code : ", resendCode);
          setAuthCode('');
          document.getElementById('authCodeInput').value = '';
        }}>
          재전송
        </Button>
      </Group>
      {errorMessage && ( // 오류 메시지가 있을 때만 표시
          <Text color="red" size="sm" style={{ marginTop: '1rem' }}>
            {errorMessage}
          </Text>
        )}
    </div>
  );
};


function ReceiveSettingEditForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const { sms_telno, user_name, sms_yn } = location.state || {}; // navigate로부터 전달된 sms_telno를 가져옴

  const [user, setUser] = useRecoilState(userState);
  const [uName, setUName] = useState(user?.user_id || 'USER_NAME');
  const [phoneNo, setPhoneNo] = useState('');
  const [smsYn, setSmsYn] = useState('Y');
  const [bsdState, setBsdState] = useRecoilState(currentBsdState);
  const [bsdNm, setBsdNm] = useRecoilState(bsdNmState);
  const [selectedBsd, setSelectedBsd] = useState(bsdState);
  const [bsdListState, setBsdListState] = useRecoilState(currentBsdListState);
  const [authCode, setAuthCode] = useRecoilState(authCodeState);
  const [generatedCode, setGeneratedCode] = useRecoilState(generatedCodeState);
  const [formData, setFormData] = useState({});

  const [defaultValues, setDefaultValues] = useState();

  const org_user_name = user_name;
  const org_sms_telno = sms_telno;
  const org_sms_yn =  sms_yn;
  console.log('Received org_sms_telno:', org_sms_telno);


  const openAuthCodeModal = (data) => {
    const newAuthCode = generateRandomNumber();
    setGeneratedCode(newAuthCode);
    send_authcode(data, newAuthCode);   // 인증번호를 보내는 SMS
    setAuthCode('');
    console.log("[EDIT 141] 인증코드 재전송 :", newAuthCode);
  
    modals.openConfirmModal({
      title: "인증번호 입력 openConfirmModal",
      children: (
        <AuthCodeInput
          data={data}
          onConfirm={(confirmedData) => {
            updateSmsReceive(bsdState, user_name, sms_telno, sms_yn, confirmedData);
            setBsdState(bsdState);
            navigate("/sms/receive", { state: { bsdState } });
            modals.closeAll();
          }}
          formData={formData}
          bsdList={bsdListState}
          onNavigate={navigate}
        />
      ),
      labels: { cancel: "취소" },
      onCancel: () => {
        console.log("[EDIT 158] 인증번호 취소. authCode:", authCode);
      },
    });
  };

  const onFormSubmit = (data) => {
    console.log("[ADD 212] onFormSubmit> data: ", data);
    setFormData(data);
    openAuthCodeModal(data);
  };

  const columns = useMemo(() => {
    setPhoneNo(sms_telno);
    setUName(user_name);
    setSmsYn(sms_yn);
    console.log('> sms_telno:', sms_telno);
    console.log('> user_name:', user_name);
    console.log('> sms_yn:', sms_yn);
    console.log("[EDIT 168] columns> bsdState:", bsdState);
    
    const baseColumns = [
      {
        key: "bsd_nm",
        name: "SMS 분사 장치",
        type: "text",
        defaultValue: bsdListState.find(item => item.value === bsdState)?.label || '기본값',
        onChange: (value) => setBsdNm(value),
      },
      {
        key: "user_name",
        name: "SMS 수신자",
        type: "text",
        defaultValue: user_name,
        onChange: (e) => {
          console.log("[ADD 248] columns> UP_SMS_USERNAME:", e.target.value);
          setUName(e.target.value);
        },
      },
      {
        key: "sms_telno",
        name: "SMS 수신 번호",
        type: "text",
        defaultValue: sms_telno,
        onChange: (e) => {
          console.log("[ADD 248] columns> UP_SMS_TELNO:", e.target.value);
          setPhoneNo(e.target.value);
        },
      },
      {
        key: "sms_yn",
        name: "SMS 발송 여부",
        type: "radio_select",
        options: [
          { value: "Y", label: "Yes" },
          { value: "N", label: "No" },
        ],
        defaultValue: sms_yn,
        onChange: (value) => {
          console.log("[EDIT 212] columns> UP_SMS_YN:", value);
          setSmsYn(value);
        },
      },
    ];

    return baseColumns;
  }, [bsdState, setBsdState, setUName, phoneNo]);

  const checkSmsTelNo = async (e) => {
      if (e.sms_telno === org_sms_telno) {
        try {
          await updateSmsReceive(bsdState, user_name, sms_telno, sms_yn, e);
          navigate("/sms/receive");
          modals.closeAll();
        } catch (error) {
          console.error('Error updating SMS receive:', error);
          alert('업데이트 중 오류가 발생했습니다. 다시 시도해 주세요.');
        }
      }
      else {
        openAuthCodeModal(e);
      }
  }

  const onSubmit = async (e) => {
    console.log(e);
    if (e.sms_telno !== org_sms_telno) {
      if (!e.sms_telno || e.sms_telno.length < 10 || e.sms_telno.length > 11) {
        alert("수신번호는 010XXXXYYYY 형태여야 합니다.");
        return;
      }
      const isSameTelNo = await checkSameTelNo(bsdState, e);
      if (isSameTelNo) {
        alert("이미 같은 번호가 등록되어 있습니다");
        return;
      }
    }
    modals.openConfirmModal({
      title: "수정",
      children: <Center>수정 하시겠습니까?</Center>,
      centered: true,
      zIndex: 2000,
      labels: { confirm: "예", cancel: "아니오" },
      onConfirm: () => {
        checkSmsTelNo(e);
      },
    });
  };

  const onDelete = () => {
    modals.openConfirmModal({
      title: "삭제",
      centered: true,
      zIndex: 2000,
      children: <Center>정말 삭제하시겠습니까? (삭제 후 복구불가)</Center>,
      labels: { confirm: "삭제", cancel: "취소" },
      confirmProps: { color: "red" },
      onConfirm: () => {
        deleteSmsReceive(bsdState, sms_telno);
        navigate("/sms/receive");
      },
    });
  };

  const SubmitButtons = () => {
    const handleCancel = () => {
      navigate("/sms/receive", { state: { bsdState } });
    };
    return (
      <Center style={{ marginTop: "1rem" }}>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            gap: "10px",
          }}
        >
          <Button type="submit">수정</Button>
          <Button color="red" onClick={() => onDelete()}>
            삭제
          </Button>
          <Button type="button" onClick={handleCancel}>취소</Button>
        </div>
      </Center>
    );
  };

  return (
    <SRD_Form
      fields={columns}
      onSubmit={onSubmit}
      submitButton={<SubmitButtons />}
      defaultValues={defaultValues}
    />
  );
}

export default ReceiveSettingEditForm;
